import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, Row, Col, Divider, Upload, Icon, DatePicker, message } from 'antd';

import {UploadOutlined} from "@ant-design/icons";
const { forwardRef, useRef, useImperativeHandle } = React;
const { Option } = Select;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};


export const SamanForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [javakType, setJavak] = useState([{id:0 , name:'समन्स'}, {id:1 , name:'वॉरंट'}, {id:2 , name:'बाल न्याय'}, {id:2 , name:'मंडळ'}, {id:3 , name:'इतर'}]);
  const [criminalType, setCriminal] = useState([{id:0 , name:'आरोपी'}, {id:1 , name:'साक्षीदार'}, {id:2 , name:'विधी संघर्ष'}, {id:2 , name:'बालक फिर्यादी'}, {id:3 , name:'आय ओ'}]);
  const [isValidImage, setisValidImage] = useState(false);
  const [filelist, setfilelist] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [district, setDistrict] = useState([]);
  const [selectedstates, setSelectedStates] = useState([]);
  const [selectedcities, setSelectedCities] = useState([]);

  useEffect(() => {
    if(props.formreset){
      form.resetFields();
      setisValidImage(false);
      setfilelist([]);

      form.setFieldsValue({state: 121, city: props.user.cityId});
      if (props.dataStates && props.dataStates.pc_countrystates && props.dataStates.pc_countrystates) {
        setStates([...props.dataStates.pc_countrystates])
      }
      if (props.dataStates && props.dataStates.pc_cities && props.dataStates.pc_cities) {
        setCities([...props.dataStates.pc_cities])
      }
      console.log(props);
      onCityChange(props.user.cityId);
    }

    if (props.dataStates && props.dataStates.basicDistricts) {
      setDistrict([...props.dataStates.basicDistricts])
    }

  }, [props]);

  const onFinish = (values) => {
    values.assigneddate = values.assigneddate._d;
    values.crimedate = values.crimedate._d;
    values.uploadchargesheet = {file: filelist[0], fileList: filelist}
    console.log(values)
    props.onFormFinish(values);
  };
  
  useImperativeHandle(ref, () => ({
    onFinish(flag) {
      // setIsSave(flag);
      form.submit();
    },
  }));

  function beforeUpload(file) {
    let isImageAllowed = false;
    if(file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('png')  || file.type.includes('pdf')){ 
      isImageAllowed = true;
    }else{
        message.error('You can only upload JPG/PNG/PDF file!');
        form.setFieldsValue({uploadpssheet:null})
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }

    setisValidImage(isImageAllowed && isLt2M);
  }
  
  const fileuploadChange = (file)=> {
    if(file.event){
      if(isValidImage){
        file.file.status = 'success';
        setfilelist([file.file]);
      }else{
      }
    }    
  }

  const onCityChange = (value) => {
    form.resetFields(["district"]);
    form.setFieldsValue({city: value});
    props.onCityChange(value, 1);
  };

  const imageprops = {
    accept : "image/png, image/jpeg, image/jpg, application/pdf", 
    maxCount:1, 
    beforeUpload:beforeUpload,
    onChange:fileuploadChange,
    fileList: filelist
  }

  return (
    <Form onFinish={onFinish} form={form}  layout="vertical">
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="sno" label="नोंद क्रमांक" rules={[{ required: true, message: "Please enter serial number." }]}>
            <Input type='number'/>
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="crimedate" label="प्राप्त दिनांक" rules={[{ required: true, message: "Please enter get date." }]}>
            <DatePicker name='getcrimedate' style={{ width: '100%' }}/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="courtname" label="कोर्टाचे नाव" rules={[{ required: true, message: "Please enter court name." }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row  gutter={24}>
        <Col span={12}>
          <Form.Item name="crimenumber" label="जावक क्रमांक" rules={[{ required: true, message: "Please enter crime number" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="casenumber" label="केस नं. " rules={[{ required: true, message: "Please enter case number." }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="crimetype" label="जावक प्रकार" rules={[{ required: true, message: "Please select crime type." }]}>
            <Select placeholder="Select a option and change input text above">
              {javakType.length && javakType.map(item =>  (
                <Option key={item.id+item.name} value={item.id}>{item.name}</Option>  
              ))}

            
            </Select>
          </Form.Item>
        </Col>
        {/* <Col span={12}>
            <Form.Item name="relatedstation" label="संबंधित पो. स्टे." rules={[{ required: true, message: "Please enter related station." }]}>
              <Input />
            </Form.Item>
          </Col> */}

        <Col span={12}>
          <Form.Item name="assigneddate" label="नेमले तारीख" rules={[{ required: true, message: "Please enter date." }]}>
          <DatePicker name='assigned_date' style={{ width: '100%' }}/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="state"
              label="राज्य"
              rules={[{ required: true, message: "Please select an state" }]}
            >
              {/* onChange={onStateChange} */}
              <Select
                placeholder="Search to Select"
                optionFilterProp="children"
                
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              //placeholder="Please select an state"
              >
                {states &&
                  states.length &&
                  states.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.state}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="city"
              label="जिल्हा"
              rules={[{ required: true, message: "Please enter user city" }]}
            >
              <Select
                onChange={onCityChange}
                placeholder="Please select an City"
                rules={[{ required: true, message: "Please select an City" }]}
              >
                {cities &&
                  cities.length &&
                  cities.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.City}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="district"
              label="आरोपीचे पोलिस ठाणे"
              rules={[{ required: true, message: "Please enter user district" }]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select an district"
              >
                {district &&
                  district.length &&
                  district.map((res, index) => (
                    <Option key={index} value={res.DistrictName}>
                      {res.DistrictName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      <Divider></Divider>

      <Row  gutter={24}>
        <Col span={12}>
          <Form.Item name="criminaltype" label="आरोपी / साक्षीदार चे नाव " rules={[{ required: true, message: "Please select type." }]}>
          <Select placeholder="Select a option and change input text above" >
            {criminalType && criminalType.length && criminalType.map(item=>(
            <Option key={item.id+item.name} value={item.id}>{item.name}</Option>  
            ))}
          </Select>
        </Form.Item>
        </Col>
        <Col span={12} >
          <Form.Item name="uploadchargesheet" label="अपलोड ऍक्शन" rules={[{ required: true, message: "Please upload sheet" }]}>
            <Upload {...imageprops}>
              <Button type="uploadsheet" icon={<UploadOutlined />}> Click to Upload</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="gurantername" label="आरोपी / साक्षीदार चे नाव " rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="address" label="पत्ता" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});